export const  roundTo = function(num: number, places: number) {
  const factor = 10 ** places;
  return Math.round(num * factor) / factor;
};


export const getChannelColor = (val) => {
  switch (val.toLowerCase()) {
    case 'online':
      return 'info';
    default:
      return 'secondary';
  }
}

export const  concatenateStrings=(...strings)=> {
  return strings.join(',');
}